import React from "react";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import EmailIcon from "@mui/icons-material/Email";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import FacebookIcon from "@mui/icons-material/Facebook";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import { Stack } from "@mui/system";
import Divider from "@mui/material/Divider";

const Footer = () => {
  return (
    <div style={{ marginTop: "50vh" }}>
      <Divider />
      <Grid
        className="footer-main"
        container
        sx={{
          fontWeight: "800",
          padding: "10px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src="/Images/Logo.jpg"
            alt="LOGO"
            style={{
              height: "50px",
              width: "50px",
              borderRadius: "50%",
            }}
          />
          <Typography
            variant="body1"
            sx={{
              fontWeight: "700",
              marginTop: "10px",
            }}
          >
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <CallIcon />
              <span>+91 82996 65230</span>
            </Stack>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            "@media (max-width: 900px)": {
              marginTop: "25px",
            },
          }}
        >
          <Link to={`/`}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Home
            </Typography>
          </Link>
          <Link to={`/download`}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Download
            </Typography>
          </Link>
          <Link to={`/gallery`}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Gallery
            </Typography>
          </Link>
          <Link to={`/teams`}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Our Team
            </Typography>
          </Link>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            "@media (max-width: 900px)": {
              marginTop: "25px",
            },
          }}
        >
          <a href="mailto:srclasses2014@gmail.com">
            <IconButton
              sx={{ border: "2px solid black", height: "40px", width: "40px" }}
            >
              <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                <EmailIcon />
              </Typography>
            </IconButton>
          </a>
          <a href="tel:+918299665230">
            <IconButton
              sx={{ border: "2px solid black", height: "40px", width: "40px" }}
            >
              <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                <AddIcCallIcon />
              </Typography>
            </IconButton>
          </a>
          <a href="https://wa.me/+918299665230">
            <IconButton
              sx={{ border: "2px solid black", height: "40px", width: "40px" }}
            >
              <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                <WhatsAppIcon />
              </Typography>
            </IconButton>
          </a>
          <IconButton
            sx={{ border: "2px solid black", height: "40px", width: "40px" }}
          >
            <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
              <FacebookIcon />
            </Typography>
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <Typography
        variant="body1"
        className="footer-main2"
        sx={{
          marginTop: "0px",
          "@media (max-width: 400px)": {
            fontSize: "0.8rem",
          },
          fontWeight: "800",
          padding: "10px",
        }}
      >
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <HomeIcon />
            <span>Shastri Nagar Near SVM Sultanpur, 228001</span>
          </div>
          <div
            style={{
              fontWeight: "800",
              fontSize: "0.8rem",
              color: "rgb(129 129 129)",
            }}
          >
            Since 2014
          </div>
        </Stack>
      </Typography>
    </div>
  );
};

export default Footer;
